export default function TrashIcon2({
  width = '18',
  height = '20',
  ...props
}: React.SVGProps<SVGSVGElement> & { width?: string; height?: string }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 3.14314H17M6.71429 6.57171V15.7146M11.2857 6.57171V15.7146M3.28571 3.14314H14.7143V16.8574C14.7143 17.4636 14.4735 18.045 14.0448 18.4737C13.6162 18.9023 13.0348 19.1431 12.4286 19.1431H5.57143C4.96522 19.1431 4.38384 18.9023 3.95518 18.4737C3.52653 18.045 3.28571 17.4636 3.28571 16.8574V3.14314ZM9 0.857422C9.57666 0.857239 10.1321 1.07503 10.5549 1.46713C10.9777 1.85924 11.2368 2.39667 11.28 2.97171L11.2857 3.14314H6.71429C6.71429 2.53693 6.9551 1.95555 7.38376 1.52689C7.81241 1.09824 8.39379 0.857422 9 0.857422Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
